module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/biblioboard_c9ac843.svg";